module.exports = __webpack_public_path__ + "static/media/view emergency maintenance.bd4ca1e0.svg";